import styled from 'styled-components';

const StyledCellWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.mini};
`;

export { StyledCellWrapper };
